import React from 'react';
import './Modal.css';

const LeavePageModal = ({ currentUser, onLeave, onStay }) => {
  return (
    <div className="modal-overlay">
      <div className="modal leave-page-modal">
        <h1 className="leave-page-h1">Hello, {currentUser}!</h1>
        
        <div className="leave-page-body">
          <h1>Leaving the page will cause your game to refresh.</h1>
          <h2>Are you sure you want to leave the page?</h2>
        </div>
        
        <div className="leave-page-buttons">
          <button 
            className="leave-page-btn"
            onClick={onLeave}
          >
            Yes
          </button>
          <button 
            className="stay-on-page-btn"
            onClick={onStay}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeavePageModal; 